import Image from 'next/image'
import styles from './home.module.css'

const brands = [
  { src: '/static/customers/bytedance.svg', alt: 'ByteDance' },
  { src: '/static/customers/airbnb.svg', alt: 'Airbnb' },
  { src: '/static/customers/nyu.svg', alt: 'New York University' },
  { src: '/static/customers/realadvisor.svg', alt: 'RealAdvisor' },
  { src: '/static/customers/umich.svg', alt: 'University of Michigan' },
  { src: '/static/customers/hope.svg', alt: 'Hope College' },
  { src: '/static/customers/gameskraft.webp', alt: 'Gameskraft' },
  { src: '/static/customers/esimple.png', alt: 'Esimple' },
  { src: '/static/customers/wizishop.png', alt: 'Wizishop' },
  { src: '/static/customers/aria.webp', alt: 'Aria' }
]

export function Brand() {
  return (
    <div
      className={styles.brands}
      role="group"
      aria-labelledby="home-brands-label"
    >
      <div className={styles.container}>
        <p id="home-brands-label" className={styles.brandLabel}>
          Used by teams at
        </p>
        <div className={styles.brandGrid}>
          {brands.map(brand => (
            <Image key={brand.src} {...brand} width={160} height={96} />
          ))}
        </div>
      </div>
    </div>
  )
}
